<script>
import { mapActions, mapState } from 'vuex';
import columns from '@/pages/promotions/giftCardCodes/moreInfo/columns';

export default {
  data() {
    return {
      columns: columns(),
    };
  },
  props: {
    clubCard: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      getClubCardInfoAction: 'promotions/getForeverClubCardInfo',
    }),
  },
  mounted() {
    this.getClubCardInfoAction(this.clubCard.id);
  },
  computed: {
    ...mapState({
      foreverClubCard: (state) => state.promotions.foreverClubCard,
    }),
  },
};
</script>

<template>
  <h1 class="text-2xl font-bold mb-2">Info about Forever club card</h1>
  <div class="wrapper">
    <div class="row-wrapper">
      <div class="item-wrapper">
        <h3>Key:</h3>
        <span>{{ foreverClubCard.key }}</span>
      </div>
      <div class="item-wrapper">
        <h3>Balance:  </h3>
        <span>{{ foreverClubCard.balance }}</span>
      </div>
    </div>
    <div class="row-wrapper">
      <div class="item-wrapper">
        <h3>Is deleted:  </h3>
        <span>{{ foreverClubCard.isDeleted }}</span>
      </div>
      <div class="item-wrapper">
        <h3>Initial balance:  </h3>
        <span>{{ foreverClubCard.initialBalance }}</span>
      </div>
    </div>
  </div>
  <h3>Paid orders:  </h3>
  <a-table
    :columns="columns"
    :dataSource="foreverClubCard.orderPayments"
    :pagination="false"
  />
</template>

<style scoped lang="scss">
.wrapper {
  padding: 25px 0;
}
.row-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.item-wrapper {
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
h3 {
  margin-right: 20px;
}
</style>
